/* @flow */
import * as React from 'react';
import { translate, Trans } from 'react-i18next';

import TimeUtils from 'common/utils/TimeUtils';

type Props = {
    expiryDate: string,
    className?: ?string,
    t: (key: string) => string
};

class PasswordExpiryMessage extends React.Component<Props> {
    _isAlreadyExpired() {
        const { expiryDate } = this.props;
        return TimeUtils.isAfter(TimeUtils.now(), expiryDate);
    }

    _isExpiringToday() {
        const { expiryDate } = this.props;
        return TimeUtils.isSame(TimeUtils.now(), expiryDate, 'day');
    }

    _getRemainingDays() {
        const { expiryDate } = this.props;
        return TimeUtils.diff({
            startDate: TimeUtils.now().startOf('day'),
            endDate: expiryDate,
            unit: 'day'
        });
    }

    render() {
        const { className, expiryDate, t } = this.props;

        const time = TimeUtils.format(expiryDate, 'LT');
        const count = this._getRemainingDays();

        return (
            <div className={className}>
                {this._isAlreadyExpired() ? (
                    t('passwordExpiry.message.expired')
                ) : this._isExpiringToday() ? (
                    <Trans i18nKey="passwordExpiry.message.today">
                        Your password will expire{' '}
                        <strong>today at {{ time }}</strong>. Kindly update
                        soon.
                    </Trans>
                ) : (
                    <Trans
                        i18nKey="passwordExpiry.message.inDays"
                        count={count}
                    >
                        Your password will expire in{' '}
                        <strong>{{ count }} days</strong>. Kindly update soon.
                    </Trans>
                )}
            </div>
        );
    }
}

export default translate('translations')(PasswordExpiryMessage);
